import PropTypes from 'prop-types';
import React from 'react';

export default class Form extends React.Component {
    onSubmit(event) {
        event.preventDefault();
    }

    render() {
        const { children } = this.props;
        return <form noValidate onSubmit={this.onSubmit.bind(this)}>{children}</form>;
    }
}

Form.propTypes = {
    children: PropTypes.node.isRequired,
};
